import React from 'react';

// Inline banner for auth feedback. `tone="error"` is an assertive alert
// (login/network/Google failures); `tone="info"` is a calmer, polite notice
// (e.g. "your session expired") that should not read as a failure.
export default function AuthError({ message, tone = 'error' }) {
  if (!message) return null;
  return (
    <div
      className={`auth-banner auth-banner-${tone}`}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
    >
      {message}
    </div>
  );
}
